import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const token = sessionStorage.getItem('token');
    const username = sessionStorage.getItem('username');
    const role = sessionStorage.getItem('role');
    const accountId = sessionStorage.getItem('accountId');

    if (!token || !username || !role ||
        token === 'undefined' || token === 'null' ||
        username === 'undefined' || username === 'null' ||
        role === 'undefined' || role === 'null') {
      this.router.navigate(['/login']);
      return false;
    }

    if (role !== 'SUPER_ADMIN' && (!accountId || accountId === 'undefined' || accountId === 'null')) {
      this.router.navigate(['/login']);
      return false;
    }

    return true;
  }
}
